import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('PRODUCT_PRICE', [
    'FORM_SALE_DISCOUNTS',
    'FORM_FACTOR',
    'TABLE_PRICES',
    'TABLE_SALE_DISCOUNTS',
    'DISCOUNT_BUTTON_EDITION'
])
